import styled from "styled-components";
import { UiConstants } from "../../data/UiConstants";
export const MenuCard = styled.div.attrs(props => props).withConfig({
  displayName: "MenuCard",
  componentId: "sc-18k08m0-0"
})(["border-radius:", ";background-color:white;overflow:auto;border:1px solid darkgray;padding:4px;margin:2px;&:hover{}min-width:", ";min-height:", ";max-width:", ";max-height:", ";"], UiConstants.BORDER_RADIUS, props => props.minWidth, props => props.minHeight, props => props.maxWidth, props => props.maxHeight);
export const MenuCardOverflowUnset = styled(MenuCard).withConfig({
  displayName: "MenuCard__MenuCardOverflowUnset",
  componentId: "sc-18k08m0-1"
})(["overflow:unset;"]);